// src/services/employee.service.js
import api from './api';

const employeeService = {
  // Get all employees with pagination and search
  getAllEmployees: async (page = 1, limit = 10, search = '', companyId = null) => {
    try {
      const params = { page, limit };
      if (search) params.search = search;
      if (companyId) params.companyId = companyId;
      
      const response = await api.get('/users', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching employees:', error);
      throw error;
    }
  },

  // Get employee by ID
  getEmployeeById: async (id) => {
    try {
      const response = await api.get(`/users/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching employee:', error);
      throw error;
    }
  },

  // Create new employee (via auth/register)
 createEmployee: async (employeeData) => {
  try {
    const response = await api.post('/users', employeeData);
    return response.data;
  } catch (error) {
    throw error;
  }
},

  // Update employee
  updateEmployee: async (id, employeeData) => {
    try {
      const response = await api.post(`/users/${id}`, employeeData);
      return response.data;
    } catch (error) {
      console.error('Error updating employee:', error);
      throw error;
    }
  },

  // Delete employee
  deleteEmployee: async (id) => {
    try {
      const response = await api.delete(`/users/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting employee:', error);
      throw error;
    }
  },

  // Get all roles
  getRoles: async () => {
    try {
      const response = await api.get('/roles');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get assignable roles (roles current user can assign)
  getAssignableRoles: async () => {
    try {
      const response = await api.get('/roles/assignable');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get employee count
  getEmployeeCount: async (companyId = null) => {
    try {
      const params = companyId ? { companyId } : {};
      const response = await api.get('/users/count', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching employee count:', error);
      throw error;
    }
  },

  // Get all employees (with optional role filter)
  getEmployees: async (companyId, page = 1, limit = 10, search = '', role = null) => {
    try {
      const params = { page, limit };
      if (search) params.search = search;
      if (companyId) params.companyId = companyId;
      if (role) params.role = role; // Add role filter

      const response = await api.get(`users/role/${role}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching employees:', error);
      throw error;
    }
  },
  
  getUsersByRole: async (roleType, companyId = null) => {
  try {
    const params = {};
    if (companyId) params.companyId = companyId;
    const response = await api.get(`/users/role/${roleType}`, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching users by role:', error);
    throw error;
  }
},

// Add these methods to src/services/employee.service.js

// ── Region / HQ / SubHQ / Godown for cascading dropdowns ─────────────────────

// Get all regions (no pagination — for dropdown)
getAllRegions: async (companyId = null) => {
  try {
    const params = {};
    const cid = companyId || localStorage.getItem('selectedCompanyId');
    if (cid) params.companyId = cid;
    const response = await api.get('/regions/all', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching regions:', error);
    throw error;
  }
},

// Get headquarters by region
getHeadquartersByRegion: async (regionId) => {
  try {
    const response = await api.get(`/headquarters/region/${regionId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching headquarters:', error);
    throw error;
  }
},

// Get sub-headquarters by headquarter
getSubHeadquartersByHQ: async (headquarterId) => {
  try {
    const response = await api.get(`/subheadquarters/headquarter/${headquarterId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching sub-headquarters:', error);
    throw error;
  }
},

// Get godowns by region
getGodownsByRegion: async (regionId) => {
  try {
    const response = await api.get(`/godowns/region/${regionId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching godowns:', error);
    throw error;
  }
},
 
// src/services/employee.service.js
getAllGodowns: async () => {
  try {
    const response = await api.get('/godowns', { params: { limit: 1000 } });
    return {
      success: response.data?.success,
      data:    response.data?.data?.godowns || [],
    };
  } catch (error) {
    console.error('Error fetching all godowns:', error);
    throw error;
  }
},

  updateEmployeeStatus: async (id, statusData) => {
    try {
  
      const response = await api.post(`/users/${id}`, statusData);
      return response.data;
    } catch (error) {
      console.error('Error updating employee status:', error);
      throw error;
    }
  },

  getGodownsByCompany: async (companyId) => {
  try {
    const response = await api.get(`/godowns/company/${companyId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching godowns by company:', error);
    throw error;
  }
},

getRegionsForGodown: async (godownId, companyId) => {
  try {
    const response = await api.get(`/godowns/${godownId}/regions`, { params: { companyId } });
    return response.data;
  } catch (error) {
    console.error('Error fetching regions for godown:', error);
    throw error;
  }
},
};



export default employeeService;